import type {ReactElement, ReactNode} from 'react';
import { useRef} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import ClickableDiv from "@Components/clickable-div/clickable-div";
import useIsContainerScrolling from '@/hooks/useIsContainerScrolling';
import styles from './scroll-to-top.module.scss';

interface ScrollToTopProps extends ScrollToTopProperties {
  id?: string;
  className?: string;
  scrollButtonClassName?: string;
  children: Array<ReactNode> | ReactNode;
}

interface ScrollToTopProperties {
  /**
   * what value should the scroll to top button should be shown at
   * it is DEFAULT_SCROLL_OFFSET = 300 by default
   */
  scrollTopOffset?: number;
}

const DEFAULT_SCROLL_OFFSET = 300;

export function ScrollToTop({id = '', className = '', scrollTopOffset = DEFAULT_SCROLL_OFFSET, scrollButtonClassName = '', ...props}: ScrollToTopProps): ReactElement<any> {
  const containerRef = useRef<HTMLDivElement>(null);
  const {scrollTop} = useIsContainerScrolling(containerRef);

  const scrollToTopHandler = () => {
    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div id={id} className={`${className} ${styles.container}`} ref={containerRef}>
      {props.children}
      {scrollTop >= scrollTopOffset ? (
        <ClickableDiv enableFocusOutline={false}
          onClick={scrollToTopHandler}
          className={`radius-round flex-row-justify-center flex-items-center content-body-white spacing-p-t-2 spacing-p-b-2 spacing-p-r-4 spacing-p-l-4 ${styles.scrollButton} ${scrollButtonClassName}`}
        >
          <Icon icon="icon-arrow-top" className="spacing-m-r-1" size={IconSize.SIZE_ICON_16} />
          <Text val={window.i18next.t('pmwjs_font_scroll_to_top')} size={TextSize.XSMALL} bold />
        </ClickableDiv>
      ) : null}
    </div>
  );
}
